import DeviceService from '../../services/device';

// initial state
const state = {
	items: [],
	groups: [],
	total: null,
	max: null,
	lastRequest: {
		params: '',
		time: 0
	}
};

// getters
const getters = {
	getDevices: state => state
};

// actions
const actions = {
	updateDevices({ commit }, params) {
		if (params === undefined) {
			params = { search: '', force: false };
		}
		if (params.search === undefined) {
			params.search = '';
		}

		var now = new Date().getTime();
		if (state.lastRequest.params === params.search && now - state.lastRequest.time < 5000 && params.force !== true) {
			return;
		}

		commit('UPDATE_LAST_REQUEST', { Params: params.search, Time: now });
		return DeviceService.getDevices(params.search).then(response => {
			commit('UPDATE_DEVICES', response.data);
		});
	}
};

// mutations
const mutations = {
	UPDATE_DEVICES(state, payload) {
		var g = 'g';
		payload.Devices.forEach(x => {
			x.stringGroupID = g + ('0000000000' + x.GroupID).slice(-10);
		});
		state.items = payload.Devices;
		state.total = payload.TotalDevices;
		state.groups = payload.Groups;
	},
	UPDATE_MAX_DEVICES(state, payload) {
		state.max = payload;
	},
	UPDATE_LAST_REQUEST(state, payload) {
		state.lastRequest.params = payload.Params;
		state.lastRequest.time = payload.Time;
	}
};
export default {
	state,
	getters,
	actions,
	mutations
};



// WEBPACK FOOTER //
// ./app/store/modules/devices.js